import { Button, Grid } from '@material-ui/core';
import { ErrorAPI } from 'api/Assessor/methods';
import { AxiosError } from 'axios';
import GenericModal, { IGenericModalProps } from 'components/GenericModal/GenericModal';
import { CircleCloseIcon, TrashIcon } from 'components/Icons';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { assembleiasAssessorActionsLoadPautas, assembleiasAssessorDeletarPauta } from 'store/modules/AssembleiasAssessorActions';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { ModalsActionsClose } from 'store/modules/ModalsActionTypes';
import { IModalProps } from 'store/modules/ModalsReducer';
import { IReducer } from 'store/Reducer';
import ErrorHandler from 'utils/ErrorHandler';
import { getToastError, getToastSuccess } from 'utils/ToasterUtils';
import { useStyles } from './styles';

export interface IConfirmDeletarPautaModalProps extends IGenericModalProps {
  key: string,
  idPauta: number,
  idEvento: number,
  titulo: string
}

export interface IConfirmDeletarPautaModal extends IModalProps {
  genericProps?: IConfirmDeletarPautaModalProps,
  modalsActionsClose: (key: string) => ModalsActionsClose,
  assembleiasAssessorDeletarPauta: (idPauta: number, callbackSuccess?: () => void, callbackError?: (error: AxiosError) => void) => void,
}

const mapStateToProps = (state:IReducer) => {
  return {
    assembleia: state.assembleiasAssessor
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  modalsActionsClose,
  assembleiasAssessorDeletarPauta
}, dispatch);

const ConfirmDeletarPautaModal = ( { genericProps, modalsActionsClose, assembleiasAssessorDeletarPauta }: IConfirmDeletarPautaModal ) => {

  const { t } = useTranslation();
  const classes = useStyles();
  const usuario = useSelector((state: IReducer) => state.auth.usuario);
  const dispatchAction = useDispatch();

  const showError = (error: AxiosError<ErrorAPI>) => {
    ErrorHandler(error.response!.data);
  }

  const toClose = useCallback((): void => {
    if (genericProps && genericProps.key) {
      modalsActionsClose(genericProps.key);
    }
  },[genericProps, modalsActionsClose])

  const atualizarPautas = useCallback(() => {
    window.setTimeout(() => {
      dispatchAction(
        assembleiasAssessorActionsLoadPautas(
          genericProps!.idEvento,
          usuario!.cpfCnpj,
          () => {
            toClose();
          },
          showError
        )
      )
    }, 2000);
  }, [dispatchAction, genericProps, usuario, toClose])

  const toDelete = () => {
    if ( genericProps && genericProps.idPauta ) {
      assembleiasAssessorDeletarPauta(
        genericProps.idPauta,
        () => {
          getToastSuccess( t("ConfirmDeletarPauta.succesDeletarPauta") )
          atualizarPautas();
          toClose();
        },
        error => {
          getToastError( error.response?.data.message || t( "ConfirmDeletarPauta.errorDeletarPauta" ) )
        }
      )
    }
  }

  return (
    <GenericModal
      title={ t("ConfirmDeletarPauta.title") }
      content={
        <Grid container className={ classes.root }>
          <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.contentText }>
            <p>
              {
                t('ConfirmDeletarPauta.confirmText', { pauta: genericProps?.titulo })
              }
            </p>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} className={ classes.toCancel }>
            <Button
              variant="contained"
              color="primary"
              onClick={ () => toClose() }
              startIcon={<CircleCloseIcon />}
            >
              { t("ConfirmDeletarPauta.cancelButton") }
            </Button>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} className={ classes.toDelete }>
            <Button
              variant="contained"
              color="primary"
              className={ classes.buttonConfirm }
              onClick={ () => toDelete() }
              startIcon={<TrashIcon />}
            >
              { t("ConfirmDeletarPauta.confirmButton") }
            </Button>
          </Grid>
        </Grid>
      }
      genericProps={{
        maxWidth: 'sm',
        onClose: toClose,
      }}
    />
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDeletarPautaModal);
